module.exports = "/_next/static/images/f085c893f49f4f961b9abe8de96621c7-bill_empty_package.png";